(() => {
  const norm = (v) => String(v || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();

  const TEAM_ALLOWED = {
    'barcelona': ['patch-laliga-participation','patch-champions-league-5-trophies'],
    'real madrid': ['patch-laliga-participation','patch-champions-league-15-trophies'],
    'atletico madrid': ['patch-laliga-atletico-madrid','patch-europa-league-3-trophies-atletico-madrid'],
    'sevilla': ['patch-laliga-participation'],
    'valencia': ['patch-laliga-participation'],
    'real betis': ['patch-laliga-participation'],
    'arsenal': ['patch-premier-league-participation'],
    'chelsea': ['patch-premier-league-participation'],
    'manchester city': ['patch-premier-league-participation','patch-world-champions'],
    'manchester united': ['patch-premier-league-participation'],
    'liverpool': ['patch-premier-league-liverpool','patch-champions-league-6-trophies-liverpool'],
    'newcastle': ['patch-premier-league-participation'],
    'tottenham': ['patch-premier-league-tottenham','patch-europa-league-3-trophies-tottenham'],
    'ac milan': ['patch-serie-a-participation','patch-champions-league-7-trophies'],
    'inter milan': ['patch-serie-a-inter-milan','patch-champions-league-3-trophies-inter-milan'],
    'juventus': ['patch-serie-a-participation'],
    'bologna': ['patch-serie-a-participation'],
    'fiorentina': ['patch-serie-a-participation'],
    'roma': ['patch-serie-a-participation'],
    'as roma': ['patch-serie-a-participation'],
    'bayern munich': ['patch-bundesliga-bayern-munich','patch-champions-league-6-trophies-bayern-munich'],
    'borussia dortmund': ['patch-bundesliga-borussia-dortmund','patch-champions-league-1-trophy-borussia-dortmund'],
    'bayer 04 leverkusen': ['patch-bundesliga-participation'],
    'bayer leverkusen': ['patch-bundesliga-participation'],
    'rb leipzig': ['patch-bundesliga-participation'],
    'psg': ['patch-ligue-1-participation','patches-uefa-champions-25-26'],
    'paris saint-germain': ['patch-ligue-1-participation','patches-uefa-champions-25-26'],
    'olympique lyonnais': ['patch-ligue-1-participation'],
    'lyon': ['patch-ligue-1-participation'],
    'marseille': ['patch-ligue-1-participation'],
    'monaco': ['patch-ligue-1-participation'],
    'benfica': ['patch-liga-portugal-benfica','patch-champions-league-2-trophies-benfica'],
    'porto': ['patch-liga-portugal-participation'],
    'sporting lisbon': ['patch-liga-portugal-participation'],

    'flamengo': ['patch-campeao-da-libertadores-flamengo','patches-libertadores-4-trophies','patch-copa-do-brasil-participation-5-titulos','patch-final-libertadores-2025','patch-libertadores-2025-campeao','patch-campeao-brasileirao-2025','patch-130-anos'],
    'palmeiras': ['patch-campeao-da-libertadores-palmeiras','patches-libertadores-3-trophies','patch-copa-do-brasil-participation-4-titulos'],
    'corinthians': ['patch-campeao-da-libertadores-1-corinthians'],
    'sao paulo': ['patch-campeao-da-libertadores-sao-paulo','patches-libertadores-3-trophies','patch-copa-do-brasil-participation-1-titulo'],
    'santos': ['patch-campeao-da-libertadores-santos','patches-libertadores-3-trophies','patch-copa-do-brasil-participation-1-titulo'],
    'gremio': ['patch-campeao-da-libertadores-gremio','patches-libertadores-3-trophies','patch-copa-do-brasil-participation-5-titulos'],
    'internacional': ['patch-campeao-da-libertadores-internacional','patches-libertadores-2-trophies','patch-copa-do-brasil-participation-1-titulo'],
    'atletico mineiro': ['patch-campeao-da-libertadores-atlerico-mineiro','patches-libertadores-1-trophies','patch-copa-do-brasil-participation-2-titulos'],
    'cruzeiro': ['patches-libertadores-2-trophies','patch-copa-do-brasil-participation-6-titulos','patch-participation-brasileirao-2026'],
    'vasco da gama': ['patch-campeao-da-libertadores-vasco-da-gama','patches-libertadores-1-trophies'],
    'vasco': ['patch-campeao-da-libertadores-vasco-da-gama','patches-libertadores-1-trophies'],
    'botafogo': ['patch-campeao-da-libertadores-botafogo','patches-libertadores-1-trophies'],
    'fluminense': ['patch-campeao-da-libertadores-fluminense','patches-libertadores-1-trophies','patch-set-fluminense-libertadores-campeao'],
  };

  const TEAM_BLOCKED_LABELS = {
    'flamengo': ['fifa club world cup 2025', 'patch world cup 2025 participation'],
    'sport recife': ['conmebol sudamericana'],
    'cruzeiro': ['conmebol libertadores'],
  };

  const CODE_TEAM = {
    '002':'real madrid','045':'barcelona','024':'atletico madrid','038':'sevilla','048':'valencia','037':'real betis',
    '016':'arsenal','018':'chelsea','015':'manchester city','014':'manchester united','017':'liverpool','020':'newcastle','019':'tottenham',
    '008':'ac milan','010':'roma','007':'inter milan','047':'juventus','059':'bologna','011':'fiorentina',
    '005':'bayern munich','006':'borussia dortmund','049':'bayer 04 leverkusen','041':'rb leipzig',
    '004':'psg','029':'olympique lyonnais','030':'marseille','051':'monaco',
    '101':'palmeiras','102':'corinthians','103':'sao paulo','104':'flamengo','105':'vasco da gama','106':'botafogo','107':'fluminense','108':'gremio','109':'internacional','110':'atletico mineiro','111':'cruzeiro','113':'santos','121':'sport recife'
  };

  const knownTeams = () => Array.from(new Set([
    ...Object.keys(TEAM_ALLOWED),
    ...Object.keys(TEAM_BLOCKED_LABELS),
    ...Object.values(CODE_TEAM),
  ])).sort((a, b) => b.length - a.length);

  let productContext = null;
  let loading = null;
  async function getProduct() {
    if (productContext) return productContext;
    if (loading) return loading;
    loading = (async () => {
      const embedded = document.querySelector('#js360-product-context');
      if (embedded) {
        try { productContext = JSON.parse(embedded.textContent || 'null'); } catch (_) {}
      }
      if (!productContext) {
        const m = location.pathname.match(/\/products\/([^/?#]+)/);
        if (!m) return null;
        try {
          const r = await fetch(`/products/${m[1]}.js`, {headers:{Accept:'application/json'}});
          if (r.ok) productContext = await r.json();
        } catch (_) {}
      }
      return productContext;
    })();
    return loading;
  }

  function teamFromProduct(p) {
    const tags = Array.isArray(p?.tags) ? p.tags : String(p?.tags || '').split(',');
    for (const raw of tags) {
      const tag = norm(raw);
      const m = tag.match(/^code-(\d{2,3})$/) || tag.match(/^(\d{2,3})$/);
      if (m && CODE_TEAM[m[1]]) return CODE_TEAM[m[1]];
    }
    for (const raw of tags) {
      const tag = String(raw || '').trim();
      if (/^meta-team-/i.test(tag)) return norm(tag.replace(/^meta-team-/i, ''));
    }
    const teams = knownTeams();
    for (const raw of tags) {
      const tag = norm(raw);
      const exact = teams.find((team) => tag === team);
      if (exact) return exact;
    }
    const text = norm(`${p?.title || ''} ${p?.handle || ''}`);
    return teams.find((team) => text.includes(team)) || '';
  }

  function allowedFor(team) {
    const key = norm(team);
    return Object.prototype.hasOwnProperty.call(TEAM_ALLOWED, key)
      ? new Set(TEAM_ALLOWED[key] || [])
      : null;
  }

  function blockedFor(team) {
    return new Set((TEAM_BLOCKED_LABELS[norm(team)] || []).map(norm));
  }

  function isBlockedLabel(blocked, label) {
    const n = norm(label);
    for (const blockedLabel of blocked) {
      if (n === blockedLabel || n.includes(blockedLabel)) return true;
    }
    return false;
  }

  async function filterPatchUI(root = document) {
    if (!location.pathname.includes('/products/')) return;
    const p = await getProduct();
    if (!p) return;
    const team = teamFromProduct(p);
    const allowed = allowedFor(team);
    const blocked = blockedFor(team);

    root.querySelectorAll('.js360-card[data-patch]').forEach((card) => {
      const handle = String(card.dataset.patch || '');
      if (handle === '__other__') return;
      const label = norm(card.dataset.patchName || card.textContent || '');
      if (isBlockedLabel(blocked, label)) {
        card.remove();
        return;
      }
      if (allowed) {
        const unsafeGeneric = label.includes(' participation') || label.includes('qualifiers');
        const keep = allowed.has(handle);
        if (!keep || (unsafeGeneric && !keep)) card.remove();
      }
    });

    root.querySelectorAll('select[data-patch-title]').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        const label = option.textContent || option.value || '';
        if (option.value && isBlockedLabel(blocked, label)) option.remove();
      });
    });

    root.querySelectorAll('.js360-group').forEach((group) => {
      const real = [...group.querySelectorAll('.js360-card[data-patch]')].filter((x) => x.dataset.patch !== '__other__');
      if (!real.length) {
        const other = group.querySelector('.js360-card[data-patch="__other__"]');
        if (!other) group.remove();
      }
    });
  }

  const run = () => filterPatchUI(document).catch(() => {});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true}); else run();
  new MutationObserver(() => requestAnimationFrame(run)).observe(document.documentElement, {childList:true, subtree:true});
})();
